var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        width: "500px",
        title: "添加备注",
        visible: _vm.dialogVisible,
        "close-on-click-modal": false,
        "append-to-body": ""
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogVisible = $event
        }
      }
    },
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          attrs: { model: _vm.form, rules: _vm.rules, "label-width": "100px" }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "订单编号" } },
            [
              _c("el-input", {
                attrs: { disabled: "" },
                model: {
                  value: _vm.form.tradeNo,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "tradeNo", $$v)
                  },
                  expression: "form.tradeNo"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "第几期" } },
            [
              _c("el-input", {
                attrs: { disabled: "" },
                model: {
                  value: _vm.form.whichPeriod,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "whichPeriod", $$v)
                  },
                  expression: "form.whichPeriod"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "拆分总金额" } },
            [
              _c("el-input", {
                attrs: { disabled: "" },
                model: {
                  value: _vm.form.rent,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "rent", $$v)
                  },
                  expression: "form.rent"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "拆分金额(元)", prop: "remark" } },
            [
              _c("el-input", {
                attrs: { type: "textarea", rows: 4, placeholder: "单位元" },
                model: {
                  value: _vm.form.spliteRent,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "spliteRent", $$v)
                  },
                  expression: "form.spliteRent"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small" },
              on: {
                click: function($event) {
                  _vm.dialogVisible = false
                }
              }
            },
            [_vm._v("取 消")]
          ),
          _c(
            "el-button",
            {
              attrs: { size: "small", type: "primary" },
              on: { click: _vm.submit }
            },
            [_vm._v("确 定")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }